import PackageList from '../layout/Admin/PackageList'
import PackageModuleOptionSorting from '../common/option-sorting/PackageModuleOptionSorting'

export default function PackageModule() {

    return (
        <div className='bg-white rounded-md w-full h-full p-4 flex-1 flex flex-col space-y-3 overflow-hidden'>
            <PackageModuleOptionSorting/>
            <PackageList />
        </div>
    )
}